const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the description editor component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('lightEditor', ['FroalaOptions', function (FroalaOptions) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        content: '=',
        focusValue: '@?',
        focusVariable: '=?',
        title: '@?',
        required: '@?',
        noTitle: '@?',
        overrideSettings: '=?'
      },
      template: require('../../../templates/directives/cms/light-editor.html'),
      controller: ['$scope', function ($scope) {
        var self = this;

        self.froalaLocalOptions = {
          height: 300,
          imageDefaultWidth: 600,
          toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', 'fontSize', 'color', 'emoticons', 'paragraphStyle', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'insertLink', 'undo', 'redo', 'customClear'],
          charCounterMax: 500,
          fontSizeDefaultSelection: 14,
          events: {
            focus: function() {
              if ($scope.focusValue) {
                $scope.focusVariable = $scope.focusValue;
              }
              $scope.$apply();
            }
          }
        };

        self.froalaOptions = Object.assign({}, FroalaOptions, self.froalaLocalOptions);

        if($scope.overrideSettings) {
          self.froalaOptions = Object.assign({}, self.froalaOptions, $scope.overrideSettings);
        };

        delete self.froalaOptions.imageAllowedTypes;
        delete self.froalaOptions.imageUploadURL;
        delete self.froalaOptions.imageInsertButtons;
      }],
      controllerAs: 'lwEditor'
    };
  }]);